const useLink = () => {
  return (value) => {
    // Ensure the value is a string
    let stringValue = typeof value === "string" ? value : String(value);

    // Convert the string to a link-friendly format
    const convertToLink = stringValue
      .replace("ù", 'u')        // Replace ù with u
      .replace("ô", 'o')        // Replace ô with o
      .replace('ç', 'c')        // Replace ç with c
      .replace(/[^\w\s]/g, '')  // Remove non-word characters except spaces
      .replace(/\s+/g, '-')  
      .toLowerCase()            // Convert to lowercase
      .trim();                  // Trim whitespace

    return convertToLink;
  };
};

export default useLink;